var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-surface-secondary w-100" }, [
    _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
      _c("div", { staticClass: "container-fluid py-3" }, [
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
              _c("div", [
                _c("button", {
                  staticClass: "btn-close text-xs",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vr opacity-20 my-1" }),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
      _c("div", { staticClass: "container-fluid vstack gap-5" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-column flex-md-row gap-3 justify-content-between",
          },
          [
            _c("div", { staticClass: "d-flex gap-3 row" }, [
              _c("div", { staticClass: "col-md-4 px-0" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "input-group input-group-sm input-group-inline",
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("search", {
                      attrs: {
                        autofocus: "",
                        "item-text": "id",
                        "item-value": "id",
                        childplaceholder:
                          "Seleccione o ingrese una ruta de entrega...",
                        endpoint: "/close/deliver-routes",
                      },
                      model: {
                        value: _vm.deliver_route_id,
                        callback: function ($$v) {
                          _vm.deliver_route_id = $$v
                        },
                        expression: "deliver_route_id",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h px-3 btn-primary",
                    attrs: { type: "button", disabled: !_vm.deliver_route_id },
                    on: {
                      click: function ($event) {
                        return _vm.FILTER()
                      },
                    },
                  },
                  [
                    _vm.loading == "filter"
                      ? _c(
                          "div",
                          {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status" },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Loading..."),
                            ]),
                          ]
                        )
                      : _c("span", [_vm._v("Filtrar")]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h px-3 btn-danger",
                    attrs: { type: "button", disabled: !_vm.deliver_route_id },
                    on: {
                      click: function ($event) {
                        return _vm.CLEAR()
                      },
                    },
                  },
                  [_c("span", [_vm._v("Limpiar")])]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _vm._m(2),
          _vm._v(" "),
          _vm.scan == true
            ? _c("div", { staticClass: "card-body" }, [
                _c("div", [
                  _c(
                    "form",
                    {
                      staticClass: "d-flex gap-3 row",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.RECEIVE()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-lg-11 col-sm-10 col-9 px-0" },
                        [
                          _c(
                            "div",
                            { staticClass: "input-group input-group-inline" },
                            [
                              _vm._m(3),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.number,
                                    expression: "number",
                                  },
                                ],
                                ref: "number",
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: "Buscar...",
                                },
                                domProps: { value: _vm.number },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.number = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn px-3 btn-primary",
                            attrs: { type: "submit", disabled: !_vm.number },
                          },
                          [
                            _vm.loading == "destination"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "spinner-border spinner-border-sm",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v("Loading..."),
                                    ]),
                                  ]
                                )
                              : _c("span", [_vm._v("Buscar")]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.scan == true
            ? _c("div", { staticClass: "card-header bg-white" }, [
                _c(
                  "h5",
                  {
                    staticClass:
                      "me-auto d-flex align-items-center justify-content-start gap-3",
                  },
                  [
                    _vm._v(
                      "\n                        Ruta de Entrega: #" +
                        _vm._s(_vm.data.id) +
                        " - " +
                        _vm._s(_vm.data.route.full_name) +
                        ". Imprimir: \n                        "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-h btn-neutral",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.PRINT()
                          },
                        },
                      },
                      [
                        _vm.print == 1
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "spinner-border spinner-border-sm mb-0",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("Loading..."),
                                ]),
                              ]
                            )
                          : _c("i", { staticClass: "bi bi-printer" }),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body p-0" },
            [
              _vm.data.packages.length > 0
                ? [
                    _c(
                      "v-data-table",
                      {
                        staticClass: "elevation-1 table-sm",
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.data.packages,
                          "hide-default-footer": "",
                          dense: "",
                          "items-per-page": -1,
                          "item-class": _vm.ITEM_ROW_BACKGROUND,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item.id",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "text-decoration-none",
                                      attrs: {
                                        to: {
                                          name: "PackageUpdate",
                                          params: { id: item.id },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(item.type) +
                                          _vm._s(item.id) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.driver",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.data.driver
                                          ? _vm.data.driver.name
                                          : ""
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _vm._v(" "),
                        _vm._v(" "),
                        _c("template", { slot: "body.append" }, [
                          _c("tr", [
                            _c("td", { staticClass: "text-start" }, [
                              _c("span", [_vm._v("Significado Colores:")]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-start green" }, [
                              _c("span", [_vm._v("Entregados")]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-start" }, [
                              _c("span", [_vm._v("Sin Escanear")]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-start yellow" }, [
                              _c("span", [_vm._v("En Inventario")]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-start" }),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-start" }),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-start" }),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ]
                : _c(
                    "p",
                    { staticClass: "text-sm text-muted text-center mb-0 py-3" },
                    [_vm._v("No hay resultados.")]
                  ),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h1", { staticClass: "h4 ls-tight" }, [_vm._v("Escaneo")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _c("i", { staticClass: "bi bi-search" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Escaneo")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _vm._v("GV"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }